export default {"src":"/_next/static/media/eye-hide.c4fedfdd.svg","height":24,"width":24};